import { render, staticRenderFns } from "./prop.vue?vue&type=template&id=13b45b3b&scoped=true&"
import script from "./prop.vue?vue&type=script&lang=js&"
export * from "./prop.vue?vue&type=script&lang=js&"
import style0 from "./prop.vue?vue&type=style&index=0&id=13b45b3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b45b3b",
  null
  
)

export default component.exports